import { FlexContainer, H4 } from "@carrotfertility/carotene"
import React from "react"

const validBackgrounds = ["lightBlue", "veryLightCarrotOrange", "mintAlternate", "lightPampas"]

export const CalloutBox = ({
  backgroundColor = "lightPampas",
  title,
  children
}: {
  backgroundColor?: "lightBlue" | "veryLightCarrotOrange" | "mintAlternate" | "lightPampas"
  title?: string
  children: React.ReactNode
}): JSX.Element => (
  <FlexContainer
    padding="medium"
    background={validBackgrounds.includes(backgroundColor) ? backgroundColor : "lightPampas"}
    borderRadius="8px"
    direction="column"
    gap="small"
  >
    {title && <H4>{title}</H4>}
    {children}
  </FlexContainer>
)
